// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2H8wB","cell":"ColumnAccessor_cell__38-Dg","firstCellAccent":"ColumnAccessor_firstCellAccent__1Que_"};